import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import ReferensiSvc from "@/services/Referensi";
import { userModule } from "../user";

interface Unit {
  id: string;
  nama: string;
  zona: string;
  kategori: string;
  unitGroup: string;
  bpjsId: string;
}

@Module({ dynamic: true, namespaced: true, store, name: "referensi-unit" })
class ReferensiUnit extends VuexModule {
  unit: Unit[] = [];

  get sessGroupUnits() {
    const grUt = userModule.user?.unit_group_id;
    return grUt ? this.unit.filter(ut => ut.unitGroup == grUt) : [];
  }

  @Mutation
  SET_UNIT(data: Unit[]) {
    this.unit = data;
  }

  @Action({ rawError: true })
  async getUnit() {
    const resp = await ReferensiSvc.getUnitPelayanan();

    this.SET_UNIT(
      resp.map(item => {
        return {
          id: item.id,
          nama: item.nama,
          zona: item.zona_pendaftaran,
          kategori: item.kategori,
          unitGroup: item.unit_group,
          bpjsId: item.bpjs_klinik_id
        };
      })
    );
  }
}

export default getModule(ReferensiUnit);
